
<template>
    <div>
    </div>
</template>


<script>

export default {
  created() {
    this.$vs.loading();
    const isLoggedIn = localStorage.getItem(
        `${process.env.VUE_APP_ACCESS_TOKEN_NAME}LoggedIn`
    );
    if(!isLoggedIn){
        const categoryId = this.$route.params.categoryId;
        const categorySlug = this.$route.query.categorySlug;
        this.$router.push({ 
            path: '/login',
            query: { 
                sharedCategoryId: categoryId,
                sharedCategorySlug: categorySlug,
            }, 
        });
    }
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
</style>
  